import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Subject, Subscription, timer } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { AlertService } from '../../_services/alert.service';
import { Globals } from '../../_models/globals';

@Component({
  selector: 'app-seller-dashboard',
  templateUrl: './seller-dashboard.component.html',
  styleUrls: ['./seller-dashboard.component.scss'],
})
export class SellerDashboardComponent implements OnInit {
  orders: any = {};
  dateSelect: any;
  private subscriptions = new Subscription();
  requestPopup: string = 'N';

  constructor(public user: User, private api: ApiIntegration, public g: Globals, private alertService: AlertService, private http: HttpClient) {
    this.getCountDataByDate();
  }

  getCountDataByDate() {
    if (!this.dateSelect) {
      this.dateSelect = {
        label: 'Today',
        fromDate: moment().format('MM/DD/YYYY'),
        toDate: moment().format('MM/DD/YYYY')
      };
    }
    let query: any = {
      accountOwnerId: this.user.accountOwnerId,
      sellerId: this.user.sellerId,
      organizationId: 1
    }
    query = { ...query, ...this.dateSelect };
    delete query.label;
    this.subscriptions.add(timer(0, 120000).subscribe((t) => {
      this.api.getSellerOrdersCount(query).subscribe((data: any) => {
        this.orders = data;
      }, err => {
        console.log(err);
      });
    }));
  }

  ngOnInit() {
  }

  closeRequestPopup() {
    this.requestPopup = 'N';
  }

  openRequestPopUP() {
    this.requestPopup = 'Y';
  }

  updateRequest() {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createWithdrawRequest?accountOwnerId=' + this.user.accountOwnerId + '&organizationId=' + this.user.organizationId + '&sellerId=' + this.user.sellerId, {}, { headers: header1 }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.alertService.success('Request', 'Updated Successfully');
        this.requestPopup = 'N';
      } else {
        this.alertService.error('Error', data['message']);
      }
    },
      (err: HttpErrorResponse) => {

        this.g.loaderDisplay = "";
      });

  }
}
